/*
 *  A place to store hardcoded (guaranteed to load) example flows. Use sparingly.
 */
export const EXAMPLEFLOW_1 = {
  flow: {
    nodes: [
      {
        width: 310,
        height: 509,
        id: "prompt-1687991312103",
        type: "prompt",
        data: {
          prompt: "What is the opening sentence of {book} by {author}?",
          n: 1,
          llms: [
            {
              key: "67b1b7c0-1594-4dac-b705-d6804ad0b96f",
              name: "Llama 3.2 1B",
              emoji: "🦙",
              model: "openrouter/meta-llama/llama-3.2-1b-instruct",
              base_model: "openrouter",
              temp: 1,
              formData: {
                shortname: "Llama 3.2 1B",
                model: "meta-llama/llama-3.2-1b-instruct",
                system_msg: "You are a helpful assistant.",
                temperature: 1,
                reasoning_effort: "off",
                reasoning_max_tokens: null,
                response_format: "text",
                tools: "",
                tool_choice: "",
                top_p: 1,
                stop: "",
                max_tokens: 400,
                seed: null,
                presence_penalty: 0,
                frequency_penalty: 0,
              },
              settings: {
                system_msg: "You are a helpful assistant.",
                temperature: 1,
                reasoning_effort: "off",
                reasoning_max_tokens: null,
                response_format: {
                  type: "text",
                },
                tools: [],
                tool_choice: "",
                top_p: 1,
                stop: [],
                max_tokens: 400,
                seed: null,
                presence_penalty: 0,
                frequency_penalty: 0,
              },
            },
            {
              key: "f7d40da2-ae54-4bc1-8c2b-8cc9c4596f1f",
              name: "Ministral 8B",
              emoji: "🌬️",
              model: "openrouter/mistralai/ministral-8b-2512",
              base_model: "openrouter",
              temp: 1,
              formData: {
                shortname: "Ministral 8B",
                model: "mistralai/ministral-8b-2512",
                system_msg: "You are a helpful assistant.",
                temperature: 1,
                reasoning_effort: "off",
                reasoning_max_tokens: null,
                response_format: "text",
                tools: "",
                tool_choice: "",
                top_p: 1,
                stop: "",
                max_tokens: 400,
                seed: null,
                presence_penalty: 0,
                frequency_penalty: 0,
              },
              settings: {
                system_msg: "You are a helpful assistant.",
                temperature: 1,
                reasoning_effort: "off",
                reasoning_max_tokens: null,
                response_format: {
                  type: "text",
                },
                tools: [],
                tool_choice: "",
                top_p: 1,
                stop: [],
                max_tokens: 400,
                seed: null,
                presence_penalty: 0,
                frequency_penalty: 0,
              },
            },
            {
              key: "bf327375-57f3-4683-8162-7db973c9aec1",
              name: "Qwen3 8B",
              emoji: "🐉",
              model: "openrouter/qwen/qwen3-8b",
              base_model: "openrouter",
              temp: 1,
              formData: {
                shortname: "Qwen3 8B",
                model: "qwen/qwen3-8b",
                system_msg: "You are a helpful assistant.",
                temperature: 1,
                reasoning_effort: "off",
                reasoning_max_tokens: null,
                response_format: "text",
                tools: "",
                tool_choice: "",
                top_p: 1,
                stop: "",
                max_tokens: 400,
                seed: null,
                presence_penalty: 0,
                frequency_penalty: 0,
              },
              settings: {
                system_msg: "You are a helpful assistant.",
                temperature: 1,
                reasoning_effort: "off",
                reasoning_max_tokens: null,
                response_format: {
                  type: "text",
                },
                tools: [],
                tool_choice: "",
                top_p: 1,
                stop: [],
                max_tokens: 400,
                seed: null,
                presence_penalty: 0,
                frequency_penalty: 0,
              },
            },
            {
              key: "db5f451f-16e2-4681-ad1d-6c7a421df309",
              name: "Gemma 4 31B",
              emoji: "♊",
              model: "openrouter/google/gemma-4-31b-it",
              base_model: "openrouter",
              temp: 1,
              formData: {
                shortname: "Gemma 4 31B",
                model: "google/gemma-4-31b-it",
                system_msg: "You are a helpful assistant.",
                temperature: 1,
                reasoning_effort: "off",
                reasoning_max_tokens: null,
                response_format: "text",
                tools: "",
                tool_choice: "",
                top_p: 1,
                stop: "",
                max_tokens: 400,
                seed: null,
                presence_penalty: 0,
                frequency_penalty: 0,
              },
              settings: {
                system_msg: "You are a helpful assistant.",
                temperature: 1,
                reasoning_effort: "off",
                reasoning_max_tokens: null,
                response_format: {
                  type: "text",
                },
                tools: [],
                tool_choice: "",
                top_p: 1,
                stop: [],
                max_tokens: 400,
                seed: null,
                presence_penalty: 0,
                frequency_penalty: 0,
              },
            },
          ],
          refresh: false,
          fields: [
            {
              text: 55,
              prompt: 8,
              fill_history: {
                book: 10,
                author: 11,
              },
              llm: {
                key: "67b1b7c0-1594-4dac-b705-d6804ad0b96f",
                name: "Llama 3.2 1B",
                emoji: "🦙",
                model: "openrouter/meta-llama/llama-3.2-1b-instruct",
                base_model: "openrouter",
                temp: 1,
                formData: {
                  shortname: "Llama 3.2 1B",
                  model: "meta-llama/llama-3.2-1b-instruct",
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: "text",
                  tools: "",
                  tool_choice: "",
                  top_p: 1,
                  stop: "",
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                settings: {
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: {
                    type: "text",
                  },
                  tools: [],
                  tool_choice: "",
                  top_p: 1,
                  stop: [],
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                progress: {
                  success: 88.88888888888889,
                  error: 0,
                },
              },
              uid: "2ad09d4a-911b-4548-81f9-d397b8d12c00",
              metavars: {
                "Book Title": 10,
                Author: 11,
                __pt: "What is the opening sentence of {book} by {author}?",
                LLM_0: "Llama 3.2 1B",
              },
            },
            {
              text: 9,
              prompt: 8,
              fill_history: {
                book: 10,
                author: 11,
              },
              llm: {
                key: "f7d40da2-ae54-4bc1-8c2b-8cc9c4596f1f",
                name: "Ministral 8B",
                emoji: "🌬️",
                model: "openrouter/mistralai/ministral-8b-2512",
                base_model: "openrouter",
                temp: 1,
                formData: {
                  shortname: "Ministral 8B",
                  model: "mistralai/ministral-8b-2512",
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: "text",
                  tools: "",
                  tool_choice: "",
                  top_p: 1,
                  stop: "",
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                settings: {
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: {
                    type: "text",
                  },
                  tools: [],
                  tool_choice: "",
                  top_p: 1,
                  stop: [],
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                progress: {
                  success: 100,
                  error: 0,
                },
              },
              uid: "91999795-4ac0-48ab-b79b-d9e49aab946a",
              metavars: {
                "Book Title": 10,
                Author: 11,
                __pt: "What is the opening sentence of {book} by {author}?",
                LLM_0: "Ministral 8B",
              },
            },
            {
              text: 9,
              prompt: 8,
              fill_history: {
                book: 10,
                author: 11,
              },
              llm: {
                key: "bf327375-57f3-4683-8162-7db973c9aec1",
                name: "Qwen3 8B",
                emoji: "🐉",
                model: "openrouter/qwen/qwen3-8b",
                base_model: "openrouter",
                temp: 1,
                formData: {
                  shortname: "Qwen3 8B",
                  model: "qwen/qwen3-8b",
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: "text",
                  tools: "",
                  tool_choice: "",
                  top_p: 1,
                  stop: "",
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                settings: {
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: {
                    type: "text",
                  },
                  tools: [],
                  tool_choice: "",
                  top_p: 1,
                  stop: [],
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                progress: {
                  success: 100,
                  error: 0,
                },
              },
              uid: "b16c6ce6-b029-4e87-a707-47a6caaad9e9",
              metavars: {
                "Book Title": 10,
                Author: 11,
                __pt: "What is the opening sentence of {book} by {author}?",
                LLM_0: "Qwen3 8B",
              },
            },
            {
              text: 45,
              prompt: 8,
              fill_history: {
                book: 10,
                author: 11,
              },
              llm: {
                key: "db5f451f-16e2-4681-ad1d-6c7a421df309",
                name: "Gemma 4 31B",
                emoji: "♊",
                model: "openrouter/google/gemma-4-31b-it",
                base_model: "openrouter",
                temp: 1,
                formData: {
                  shortname: "Gemma 4 31B",
                  model: "google/gemma-4-31b-it",
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: "text",
                  tools: "",
                  tool_choice: "",
                  top_p: 1,
                  stop: "",
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                settings: {
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: {
                    type: "text",
                  },
                  tools: [],
                  tool_choice: "",
                  top_p: 1,
                  stop: [],
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                progress: {
                  success: 100,
                  error: 0,
                },
              },
              uid: "c879cec0-3649-4b87-a414-2d005f1bb2a2",
              metavars: {
                "Book Title": 10,
                Author: 11,
                __pt: "What is the opening sentence of {book} by {author}?",
                LLM_0: "Gemma 4 31B",
              },
            },
            {
              text: 58,
              prompt: 16,
              fill_history: {
                book: 18,
                author: 19,
              },
              llm: {
                key: "67b1b7c0-1594-4dac-b705-d6804ad0b96f",
                name: "Llama 3.2 1B",
                emoji: "🦙",
                model: "openrouter/meta-llama/llama-3.2-1b-instruct",
                base_model: "openrouter",
                temp: 1,
                formData: {
                  shortname: "Llama 3.2 1B",
                  model: "meta-llama/llama-3.2-1b-instruct",
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: "text",
                  tools: "",
                  tool_choice: "",
                  top_p: 1,
                  stop: "",
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                settings: {
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: {
                    type: "text",
                  },
                  tools: [],
                  tool_choice: "",
                  top_p: 1,
                  stop: [],
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                progress: {
                  success: 88.88888888888889,
                  error: 0,
                },
              },
              uid: "441c8527-439d-400c-ac7d-e9fbdede390f",
              metavars: {
                "Book Title": 18,
                Author: 19,
                __pt: "What is the opening sentence of {book} by {author}?",
                LLM_0: "Llama 3.2 1B",
              },
            },
            {
              text: 17,
              prompt: 16,
              fill_history: {
                book: 18,
                author: 19,
              },
              llm: {
                key: "f7d40da2-ae54-4bc1-8c2b-8cc9c4596f1f",
                name: "Ministral 8B",
                emoji: "🌬️",
                model: "openrouter/mistralai/ministral-8b-2512",
                base_model: "openrouter",
                temp: 1,
                formData: {
                  shortname: "Ministral 8B",
                  model: "mistralai/ministral-8b-2512",
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: "text",
                  tools: "",
                  tool_choice: "",
                  top_p: 1,
                  stop: "",
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                settings: {
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: {
                    type: "text",
                  },
                  tools: [],
                  tool_choice: "",
                  top_p: 1,
                  stop: [],
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                progress: {
                  success: 100,
                  error: 0,
                },
              },
              uid: "da19f46b-1af1-4bad-9659-20051df12c2d",
              metavars: {
                "Book Title": 18,
                Author: 19,
                __pt: "What is the opening sentence of {book} by {author}?",
                LLM_0: "Ministral 8B",
              },
            },
            {
              text: 38,
              prompt: 16,
              fill_history: {
                book: 18,
                author: 19,
              },
              llm: {
                key: "bf327375-57f3-4683-8162-7db973c9aec1",
                name: "Qwen3 8B",
                emoji: "🐉",
                model: "openrouter/qwen/qwen3-8b",
                base_model: "openrouter",
                temp: 1,
                formData: {
                  shortname: "Qwen3 8B",
                  model: "qwen/qwen3-8b",
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: "text",
                  tools: "",
                  tool_choice: "",
                  top_p: 1,
                  stop: "",
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                settings: {
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: {
                    type: "text",
                  },
                  tools: [],
                  tool_choice: "",
                  top_p: 1,
                  stop: [],
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                progress: {
                  success: 100,
                  error: 0,
                },
              },
              uid: "a252e69f-5b82-4d3f-b6c1-7725fe33a6e4",
              metavars: {
                "Book Title": 18,
                Author: 19,
                __pt: "What is the opening sentence of {book} by {author}?",
                LLM_0: "Qwen3 8B",
              },
            },
            {
              text: 41,
              prompt: 16,
              fill_history: {
                book: 18,
                author: 19,
              },
              llm: {
                key: "db5f451f-16e2-4681-ad1d-6c7a421df309",
                name: "Gemma 4 31B",
                emoji: "♊",
                model: "openrouter/google/gemma-4-31b-it",
                base_model: "openrouter",
                temp: 1,
                formData: {
                  shortname: "Gemma 4 31B",
                  model: "google/gemma-4-31b-it",
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: "text",
                  tools: "",
                  tool_choice: "",
                  top_p: 1,
                  stop: "",
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                settings: {
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: {
                    type: "text",
                  },
                  tools: [],
                  tool_choice: "",
                  top_p: 1,
                  stop: [],
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                progress: {
                  success: 100,
                  error: 0,
                },
              },
              uid: "c8d13d82-81ba-4168-849f-41ff0c3e2d4c",
              metavars: {
                "Book Title": 18,
                Author: 19,
                __pt: "What is the opening sentence of {book} by {author}?",
                LLM_0: "Gemma 4 31B",
              },
            },
            {
              text: 57,
              prompt: 0,
              fill_history: {
                book: 2,
                author: 3,
              },
              llm: {
                key: "67b1b7c0-1594-4dac-b705-d6804ad0b96f",
                name: "Llama 3.2 1B",
                emoji: "🦙",
                model: "openrouter/meta-llama/llama-3.2-1b-instruct",
                base_model: "openrouter",
                temp: 1,
                formData: {
                  shortname: "Llama 3.2 1B",
                  model: "meta-llama/llama-3.2-1b-instruct",
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: "text",
                  tools: "",
                  tool_choice: "",
                  top_p: 1,
                  stop: "",
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                settings: {
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: {
                    type: "text",
                  },
                  tools: [],
                  tool_choice: "",
                  top_p: 1,
                  stop: [],
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                progress: {
                  success: 88.88888888888889,
                  error: 0,
                },
              },
              uid: "3979ba3b-fe27-4693-b372-ad5882fe2ff9",
              metavars: {
                "Book Title": 2,
                Author: 3,
                __pt: "What is the opening sentence of {book} by {author}?",
                LLM_0: "Llama 3.2 1B",
              },
            },
            {
              text: 1,
              prompt: 0,
              fill_history: {
                book: 2,
                author: 3,
              },
              llm: {
                key: "f7d40da2-ae54-4bc1-8c2b-8cc9c4596f1f",
                name: "Ministral 8B",
                emoji: "🌬️",
                model: "openrouter/mistralai/ministral-8b-2512",
                base_model: "openrouter",
                temp: 1,
                formData: {
                  shortname: "Ministral 8B",
                  model: "mistralai/ministral-8b-2512",
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: "text",
                  tools: "",
                  tool_choice: "",
                  top_p: 1,
                  stop: "",
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                settings: {
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: {
                    type: "text",
                  },
                  tools: [],
                  tool_choice: "",
                  top_p: 1,
                  stop: [],
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                progress: {
                  success: 100,
                  error: 0,
                },
              },
              uid: "55622b27-476c-44d8-9377-2ae07ed2e714",
              metavars: {
                "Book Title": 2,
                Author: 3,
                __pt: "What is the opening sentence of {book} by {author}?",
                LLM_0: "Ministral 8B",
              },
            },
            {
              text: 37,
              prompt: 0,
              fill_history: {
                book: 2,
                author: 3,
              },
              llm: {
                key: "bf327375-57f3-4683-8162-7db973c9aec1",
                name: "Qwen3 8B",
                emoji: "🐉",
                model: "openrouter/qwen/qwen3-8b",
                base_model: "openrouter",
                temp: 1,
                formData: {
                  shortname: "Qwen3 8B",
                  model: "qwen/qwen3-8b",
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: "text",
                  tools: "",
                  tool_choice: "",
                  top_p: 1,
                  stop: "",
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                settings: {
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: {
                    type: "text",
                  },
                  tools: [],
                  tool_choice: "",
                  top_p: 1,
                  stop: [],
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                progress: {
                  success: 100,
                  error: 0,
                },
              },
              uid: "8c972ed8-0d89-4040-9bfd-19e75e036368",
              metavars: {
                "Book Title": 2,
                Author: 3,
                __pt: "What is the opening sentence of {book} by {author}?",
                LLM_0: "Qwen3 8B",
              },
            },
            {
              text: 51,
              prompt: 0,
              fill_history: {
                book: 2,
                author: 3,
              },
              llm: {
                key: "db5f451f-16e2-4681-ad1d-6c7a421df309",
                name: "Gemma 4 31B",
                emoji: "♊",
                model: "openrouter/google/gemma-4-31b-it",
                base_model: "openrouter",
                temp: 1,
                formData: {
                  shortname: "Gemma 4 31B",
                  model: "google/gemma-4-31b-it",
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: "text",
                  tools: "",
                  tool_choice: "",
                  top_p: 1,
                  stop: "",
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                settings: {
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: {
                    type: "text",
                  },
                  tools: [],
                  tool_choice: "",
                  top_p: 1,
                  stop: [],
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                progress: {
                  success: 100,
                  error: 0,
                },
              },
              uid: "ea3849d6-887b-4772-8c1e-c892c610bd0c",
              metavars: {
                "Book Title": 2,
                Author: 3,
                __pt: "What is the opening sentence of {book} by {author}?",
                LLM_0: "Gemma 4 31B",
              },
            },
            {
              text: 56,
              prompt: 12,
              fill_history: {
                book: 14,
                author: 15,
              },
              llm: {
                key: "67b1b7c0-1594-4dac-b705-d6804ad0b96f",
                name: "Llama 3.2 1B",
                emoji: "🦙",
                model: "openrouter/meta-llama/llama-3.2-1b-instruct",
                base_model: "openrouter",
                temp: 1,
                formData: {
                  shortname: "Llama 3.2 1B",
                  model: "meta-llama/llama-3.2-1b-instruct",
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: "text",
                  tools: "",
                  tool_choice: "",
                  top_p: 1,
                  stop: "",
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                settings: {
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: {
                    type: "text",
                  },
                  tools: [],
                  tool_choice: "",
                  top_p: 1,
                  stop: [],
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                progress: {
                  success: 88.88888888888889,
                  error: 0,
                },
              },
              uid: "d82f4517-721a-4cba-9729-55b1f2ad02b5",
              metavars: {
                "Book Title": 14,
                Author: 15,
                __pt: "What is the opening sentence of {book} by {author}?",
                LLM_0: "Llama 3.2 1B",
              },
            },
            {
              text: 13,
              prompt: 12,
              fill_history: {
                book: 14,
                author: 15,
              },
              llm: {
                key: "f7d40da2-ae54-4bc1-8c2b-8cc9c4596f1f",
                name: "Ministral 8B",
                emoji: "🌬️",
                model: "openrouter/mistralai/ministral-8b-2512",
                base_model: "openrouter",
                temp: 1,
                formData: {
                  shortname: "Ministral 8B",
                  model: "mistralai/ministral-8b-2512",
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: "text",
                  tools: "",
                  tool_choice: "",
                  top_p: 1,
                  stop: "",
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                settings: {
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: {
                    type: "text",
                  },
                  tools: [],
                  tool_choice: "",
                  top_p: 1,
                  stop: [],
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                progress: {
                  success: 100,
                  error: 0,
                },
              },
              uid: "2a946b37-8052-44e7-b3b0-67e1165846f8",
              metavars: {
                "Book Title": 14,
                Author: 15,
                __pt: "What is the opening sentence of {book} by {author}?",
                LLM_0: "Ministral 8B",
              },
            },
            {
              text: 43,
              prompt: 12,
              fill_history: {
                book: 14,
                author: 15,
              },
              llm: {
                key: "bf327375-57f3-4683-8162-7db973c9aec1",
                name: "Qwen3 8B",
                emoji: "🐉",
                model: "openrouter/qwen/qwen3-8b",
                base_model: "openrouter",
                temp: 1,
                formData: {
                  shortname: "Qwen3 8B",
                  model: "qwen/qwen3-8b",
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: "text",
                  tools: "",
                  tool_choice: "",
                  top_p: 1,
                  stop: "",
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                settings: {
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: {
                    type: "text",
                  },
                  tools: [],
                  tool_choice: "",
                  top_p: 1,
                  stop: [],
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                progress: {
                  success: 100,
                  error: 0,
                },
              },
              uid: "539eba74-9656-4209-9f40-db37870d62e4",
              metavars: {
                "Book Title": 14,
                Author: 15,
                __pt: "What is the opening sentence of {book} by {author}?",
                LLM_0: "Qwen3 8B",
              },
            },
            {
              text: 44,
              prompt: 12,
              fill_history: {
                book: 14,
                author: 15,
              },
              llm: {
                key: "db5f451f-16e2-4681-ad1d-6c7a421df309",
                name: "Gemma 4 31B",
                emoji: "♊",
                model: "openrouter/google/gemma-4-31b-it",
                base_model: "openrouter",
                temp: 1,
                formData: {
                  shortname: "Gemma 4 31B",
                  model: "google/gemma-4-31b-it",
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: "text",
                  tools: "",
                  tool_choice: "",
                  top_p: 1,
                  stop: "",
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                settings: {
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: {
                    type: "text",
                  },
                  tools: [],
                  tool_choice: "",
                  top_p: 1,
                  stop: [],
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                progress: {
                  success: 100,
                  error: 0,
                },
              },
              uid: "e65eef41-eb19-470c-8d69-fb1e5806b0fd",
              metavars: {
                "Book Title": 14,
                Author: 15,
                __pt: "What is the opening sentence of {book} by {author}?",
                LLM_0: "Gemma 4 31B",
              },
            },
            {
              text: 59,
              prompt: 4,
              fill_history: {
                book: 6,
                author: 7,
              },
              llm: {
                key: "67b1b7c0-1594-4dac-b705-d6804ad0b96f",
                name: "Llama 3.2 1B",
                emoji: "🦙",
                model: "openrouter/meta-llama/llama-3.2-1b-instruct",
                base_model: "openrouter",
                temp: 1,
                formData: {
                  shortname: "Llama 3.2 1B",
                  model: "meta-llama/llama-3.2-1b-instruct",
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: "text",
                  tools: "",
                  tool_choice: "",
                  top_p: 1,
                  stop: "",
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                settings: {
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: {
                    type: "text",
                  },
                  tools: [],
                  tool_choice: "",
                  top_p: 1,
                  stop: [],
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                progress: {
                  success: 88.88888888888889,
                  error: 0,
                },
              },
              uid: "b7014ea7-efa0-4e6f-aa72-a7e938b909b9",
              metavars: {
                "Book Title": 6,
                Author: 7,
                __pt: "What is the opening sentence of {book} by {author}?",
                LLM_0: "Llama 3.2 1B",
              },
            },
            {
              text: 5,
              prompt: 4,
              fill_history: {
                book: 6,
                author: 7,
              },
              llm: {
                key: "f7d40da2-ae54-4bc1-8c2b-8cc9c4596f1f",
                name: "Ministral 8B",
                emoji: "🌬️",
                model: "openrouter/mistralai/ministral-8b-2512",
                base_model: "openrouter",
                temp: 1,
                formData: {
                  shortname: "Ministral 8B",
                  model: "mistralai/ministral-8b-2512",
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: "text",
                  tools: "",
                  tool_choice: "",
                  top_p: 1,
                  stop: "",
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                settings: {
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: {
                    type: "text",
                  },
                  tools: [],
                  tool_choice: "",
                  top_p: 1,
                  stop: [],
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                progress: {
                  success: 100,
                  error: 0,
                },
              },
              uid: "a52cb924-25c3-464a-b6ca-843d3c7a3d5f",
              metavars: {
                "Book Title": 6,
                Author: 7,
                __pt: "What is the opening sentence of {book} by {author}?",
                LLM_0: "Ministral 8B",
              },
            },
            {
              text: 42,
              prompt: 4,
              fill_history: {
                book: 6,
                author: 7,
              },
              llm: {
                key: "bf327375-57f3-4683-8162-7db973c9aec1",
                name: "Qwen3 8B",
                emoji: "🐉",
                model: "openrouter/qwen/qwen3-8b",
                base_model: "openrouter",
                temp: 1,
                formData: {
                  shortname: "Qwen3 8B",
                  model: "qwen/qwen3-8b",
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: "text",
                  tools: "",
                  tool_choice: "",
                  top_p: 1,
                  stop: "",
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                settings: {
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: {
                    type: "text",
                  },
                  tools: [],
                  tool_choice: "",
                  top_p: 1,
                  stop: [],
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                progress: {
                  success: 100,
                  error: 0,
                },
              },
              uid: "4bcad951-06f8-4814-bd57-405791fc982c",
              metavars: {
                "Book Title": 6,
                Author: 7,
                __pt: "What is the opening sentence of {book} by {author}?",
                LLM_0: "Qwen3 8B",
              },
            },
            {
              text: 52,
              prompt: 4,
              fill_history: {
                book: 6,
                author: 7,
              },
              llm: {
                key: "db5f451f-16e2-4681-ad1d-6c7a421df309",
                name: "Gemma 4 31B",
                emoji: "♊",
                model: "openrouter/google/gemma-4-31b-it",
                base_model: "openrouter",
                temp: 1,
                formData: {
                  shortname: "Gemma 4 31B",
                  model: "google/gemma-4-31b-it",
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: "text",
                  tools: "",
                  tool_choice: "",
                  top_p: 1,
                  stop: "",
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                settings: {
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: {
                    type: "text",
                  },
                  tools: [],
                  tool_choice: "",
                  top_p: 1,
                  stop: [],
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                progress: {
                  success: 100,
                  error: 0,
                },
              },
              uid: "58a14690-8b11-4a2f-895a-4de16a79d272",
              metavars: {
                "Book Title": 6,
                Author: 7,
                __pt: "What is the opening sentence of {book} by {author}?",
                LLM_0: "Gemma 4 31B",
              },
            },
            {
              text: 47,
              prompt: 28,
              fill_history: {
                book: 30,
                author: 31,
              },
              llm: {
                key: "67b1b7c0-1594-4dac-b705-d6804ad0b96f",
                name: "Llama 3.2 1B",
                emoji: "🦙",
                model: "openrouter/meta-llama/llama-3.2-1b-instruct",
                base_model: "openrouter",
                temp: 1,
                formData: {
                  shortname: "Llama 3.2 1B",
                  model: "meta-llama/llama-3.2-1b-instruct",
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: "text",
                  tools: "",
                  tool_choice: "",
                  top_p: 1,
                  stop: "",
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                settings: {
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: {
                    type: "text",
                  },
                  tools: [],
                  tool_choice: "",
                  top_p: 1,
                  stop: [],
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                progress: {
                  success: 88.88888888888889,
                  error: 0,
                },
              },
              uid: "a532566a-8de2-4572-8e72-02091d55884f",
              metavars: {
                "Book Title": 30,
                Author: 31,
                __pt: "What is the opening sentence of {book} by {author}?",
                LLM_0: "Llama 3.2 1B",
              },
            },
            {
              text: 29,
              prompt: 28,
              fill_history: {
                book: 30,
                author: 31,
              },
              llm: {
                key: "f7d40da2-ae54-4bc1-8c2b-8cc9c4596f1f",
                name: "Ministral 8B",
                emoji: "🌬️",
                model: "openrouter/mistralai/ministral-8b-2512",
                base_model: "openrouter",
                temp: 1,
                formData: {
                  shortname: "Ministral 8B",
                  model: "mistralai/ministral-8b-2512",
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: "text",
                  tools: "",
                  tool_choice: "",
                  top_p: 1,
                  stop: "",
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                settings: {
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: {
                    type: "text",
                  },
                  tools: [],
                  tool_choice: "",
                  top_p: 1,
                  stop: [],
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                progress: {
                  success: 100,
                  error: 0,
                },
              },
              uid: "6d02bca3-2193-4234-9bc0-fb01c9f77710",
              metavars: {
                "Book Title": 30,
                Author: 31,
                __pt: "What is the opening sentence of {book} by {author}?",
                LLM_0: "Ministral 8B",
              },
            },
            {
              text: 40,
              prompt: 28,
              fill_history: {
                book: 30,
                author: 31,
              },
              llm: {
                key: "bf327375-57f3-4683-8162-7db973c9aec1",
                name: "Qwen3 8B",
                emoji: "🐉",
                model: "openrouter/qwen/qwen3-8b",
                base_model: "openrouter",
                temp: 1,
                formData: {
                  shortname: "Qwen3 8B",
                  model: "qwen/qwen3-8b",
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: "text",
                  tools: "",
                  tool_choice: "",
                  top_p: 1,
                  stop: "",
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                settings: {
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: {
                    type: "text",
                  },
                  tools: [],
                  tool_choice: "",
                  top_p: 1,
                  stop: [],
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                progress: {
                  success: 100,
                  error: 0,
                },
              },
              uid: "e294af6a-21b3-4e07-9c09-d3e13017514b",
              metavars: {
                "Book Title": 30,
                Author: 31,
                __pt: "What is the opening sentence of {book} by {author}?",
                LLM_0: "Qwen3 8B",
              },
            },
            {
              text: 54,
              prompt: 28,
              fill_history: {
                book: 30,
                author: 31,
              },
              llm: {
                key: "db5f451f-16e2-4681-ad1d-6c7a421df309",
                name: "Gemma 4 31B",
                emoji: "♊",
                model: "openrouter/google/gemma-4-31b-it",
                base_model: "openrouter",
                temp: 1,
                formData: {
                  shortname: "Gemma 4 31B",
                  model: "google/gemma-4-31b-it",
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: "text",
                  tools: "",
                  tool_choice: "",
                  top_p: 1,
                  stop: "",
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                settings: {
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: {
                    type: "text",
                  },
                  tools: [],
                  tool_choice: "",
                  top_p: 1,
                  stop: [],
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                progress: {
                  success: 100,
                  error: 0,
                },
              },
              uid: "8c5bfb7e-0abe-4a5d-8f44-da34ab71eada",
              metavars: {
                "Book Title": 30,
                Author: 31,
                __pt: "What is the opening sentence of {book} by {author}?",
                LLM_0: "Gemma 4 31B",
              },
            },
            {
              text: 61,
              prompt: 24,
              fill_history: {
                book: 26,
                author: 27,
              },
              llm: {
                key: "67b1b7c0-1594-4dac-b705-d6804ad0b96f",
                name: "Llama 3.2 1B",
                emoji: "🦙",
                model: "openrouter/meta-llama/llama-3.2-1b-instruct",
                base_model: "openrouter",
                temp: 1,
                formData: {
                  shortname: "Llama 3.2 1B",
                  model: "meta-llama/llama-3.2-1b-instruct",
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: "text",
                  tools: "",
                  tool_choice: "",
                  top_p: 1,
                  stop: "",
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                settings: {
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: {
                    type: "text",
                  },
                  tools: [],
                  tool_choice: "",
                  top_p: 1,
                  stop: [],
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                progress: {
                  success: 88.88888888888889,
                  error: 0,
                },
              },
              uid: "22c6d341-9f01-4186-be96-927311830115",
              metavars: {
                "Book Title": 26,
                Author: 27,
                __pt: "What is the opening sentence of {book} by {author}?",
                LLM_0: "Llama 3.2 1B",
              },
            },
            {
              text: 25,
              prompt: 24,
              fill_history: {
                book: 26,
                author: 27,
              },
              llm: {
                key: "f7d40da2-ae54-4bc1-8c2b-8cc9c4596f1f",
                name: "Ministral 8B",
                emoji: "🌬️",
                model: "openrouter/mistralai/ministral-8b-2512",
                base_model: "openrouter",
                temp: 1,
                formData: {
                  shortname: "Ministral 8B",
                  model: "mistralai/ministral-8b-2512",
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: "text",
                  tools: "",
                  tool_choice: "",
                  top_p: 1,
                  stop: "",
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                settings: {
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: {
                    type: "text",
                  },
                  tools: [],
                  tool_choice: "",
                  top_p: 1,
                  stop: [],
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                progress: {
                  success: 100,
                  error: 0,
                },
              },
              uid: "b7f119b5-5478-4d9c-8cfe-10d31a1a3686",
              metavars: {
                "Book Title": 26,
                Author: 27,
                __pt: "What is the opening sentence of {book} by {author}?",
                LLM_0: "Ministral 8B",
              },
            },
            {
              text: 50,
              prompt: 24,
              fill_history: {
                book: 26,
                author: 27,
              },
              llm: {
                key: "bf327375-57f3-4683-8162-7db973c9aec1",
                name: "Qwen3 8B",
                emoji: "🐉",
                model: "openrouter/qwen/qwen3-8b",
                base_model: "openrouter",
                temp: 1,
                formData: {
                  shortname: "Qwen3 8B",
                  model: "qwen/qwen3-8b",
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: "text",
                  tools: "",
                  tool_choice: "",
                  top_p: 1,
                  stop: "",
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                settings: {
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: {
                    type: "text",
                  },
                  tools: [],
                  tool_choice: "",
                  top_p: 1,
                  stop: [],
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                progress: {
                  success: 100,
                  error: 0,
                },
              },
              uid: "593fa71f-7be1-42f1-a27c-3b8e681d5a67",
              metavars: {
                "Book Title": 26,
                Author: 27,
                __pt: "What is the opening sentence of {book} by {author}?",
                LLM_0: "Qwen3 8B",
              },
            },
            {
              text: 46,
              prompt: 24,
              fill_history: {
                book: 26,
                author: 27,
              },
              llm: {
                key: "db5f451f-16e2-4681-ad1d-6c7a421df309",
                name: "Gemma 4 31B",
                emoji: "♊",
                model: "openrouter/google/gemma-4-31b-it",
                base_model: "openrouter",
                temp: 1,
                formData: {
                  shortname: "Gemma 4 31B",
                  model: "google/gemma-4-31b-it",
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: "text",
                  tools: "",
                  tool_choice: "",
                  top_p: 1,
                  stop: "",
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                settings: {
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: {
                    type: "text",
                  },
                  tools: [],
                  tool_choice: "",
                  top_p: 1,
                  stop: [],
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                progress: {
                  success: 100,
                  error: 0,
                },
              },
              uid: "717c4c08-1411-433b-a505-6f7ec091c3cb",
              metavars: {
                "Book Title": 26,
                Author: 27,
                __pt: "What is the opening sentence of {book} by {author}?",
                LLM_0: "Gemma 4 31B",
              },
            },
            {
              text: 53,
              prompt: 20,
              fill_history: {
                book: 22,
                author: 23,
              },
              llm: {
                key: "67b1b7c0-1594-4dac-b705-d6804ad0b96f",
                name: "Llama 3.2 1B",
                emoji: "🦙",
                model: "openrouter/meta-llama/llama-3.2-1b-instruct",
                base_model: "openrouter",
                temp: 1,
                formData: {
                  shortname: "Llama 3.2 1B",
                  model: "meta-llama/llama-3.2-1b-instruct",
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: "text",
                  tools: "",
                  tool_choice: "",
                  top_p: 1,
                  stop: "",
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                settings: {
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: {
                    type: "text",
                  },
                  tools: [],
                  tool_choice: "",
                  top_p: 1,
                  stop: [],
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                progress: {
                  success: 88.88888888888889,
                  error: 0,
                },
              },
              uid: "62e000b3-3257-4d6e-b556-e14e0502a6ed",
              metavars: {
                "Book Title": 22,
                Author: 23,
                __pt: "What is the opening sentence of {book} by {author}?",
                LLM_0: "Llama 3.2 1B",
              },
            },
            {
              text: 21,
              prompt: 20,
              fill_history: {
                book: 22,
                author: 23,
              },
              llm: {
                key: "f7d40da2-ae54-4bc1-8c2b-8cc9c4596f1f",
                name: "Ministral 8B",
                emoji: "🌬️",
                model: "openrouter/mistralai/ministral-8b-2512",
                base_model: "openrouter",
                temp: 1,
                formData: {
                  shortname: "Ministral 8B",
                  model: "mistralai/ministral-8b-2512",
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: "text",
                  tools: "",
                  tool_choice: "",
                  top_p: 1,
                  stop: "",
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                settings: {
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: {
                    type: "text",
                  },
                  tools: [],
                  tool_choice: "",
                  top_p: 1,
                  stop: [],
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                progress: {
                  success: 100,
                  error: 0,
                },
              },
              uid: "ccefccf7-7446-4a42-94ee-edc2e76c5a0a",
              metavars: {
                "Book Title": 22,
                Author: 23,
                __pt: "What is the opening sentence of {book} by {author}?",
                LLM_0: "Ministral 8B",
              },
            },
            {
              text: 49,
              prompt: 20,
              fill_history: {
                book: 22,
                author: 23,
              },
              llm: {
                key: "bf327375-57f3-4683-8162-7db973c9aec1",
                name: "Qwen3 8B",
                emoji: "🐉",
                model: "openrouter/qwen/qwen3-8b",
                base_model: "openrouter",
                temp: 1,
                formData: {
                  shortname: "Qwen3 8B",
                  model: "qwen/qwen3-8b",
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: "text",
                  tools: "",
                  tool_choice: "",
                  top_p: 1,
                  stop: "",
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                settings: {
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: {
                    type: "text",
                  },
                  tools: [],
                  tool_choice: "",
                  top_p: 1,
                  stop: [],
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                progress: {
                  success: 100,
                  error: 0,
                },
              },
              uid: "f0893573-fa42-4b0a-bf15-24ffee06e540",
              metavars: {
                "Book Title": 22,
                Author: 23,
                __pt: "What is the opening sentence of {book} by {author}?",
                LLM_0: "Qwen3 8B",
              },
            },
            {
              text: 39,
              prompt: 20,
              fill_history: {
                book: 22,
                author: 23,
              },
              llm: {
                key: "db5f451f-16e2-4681-ad1d-6c7a421df309",
                name: "Gemma 4 31B",
                emoji: "♊",
                model: "openrouter/google/gemma-4-31b-it",
                base_model: "openrouter",
                temp: 1,
                formData: {
                  shortname: "Gemma 4 31B",
                  model: "google/gemma-4-31b-it",
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: "text",
                  tools: "",
                  tool_choice: "",
                  top_p: 1,
                  stop: "",
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                settings: {
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: {
                    type: "text",
                  },
                  tools: [],
                  tool_choice: "",
                  top_p: 1,
                  stop: [],
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                progress: {
                  success: 100,
                  error: 0,
                },
              },
              uid: "06343fe1-e70e-406d-8e0f-70231e835afa",
              metavars: {
                "Book Title": 22,
                Author: 23,
                __pt: "What is the opening sentence of {book} by {author}?",
                LLM_0: "Gemma 4 31B",
              },
            },
            {
              text: 60,
              prompt: 32,
              fill_history: {
                book: 34,
                author: 35,
              },
              llm: {
                key: "67b1b7c0-1594-4dac-b705-d6804ad0b96f",
                name: "Llama 3.2 1B",
                emoji: "🦙",
                model: "openrouter/meta-llama/llama-3.2-1b-instruct",
                base_model: "openrouter",
                temp: 1,
                formData: {
                  shortname: "Llama 3.2 1B",
                  model: "meta-llama/llama-3.2-1b-instruct",
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: "text",
                  tools: "",
                  tool_choice: "",
                  top_p: 1,
                  stop: "",
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                settings: {
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: {
                    type: "text",
                  },
                  tools: [],
                  tool_choice: "",
                  top_p: 1,
                  stop: [],
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                progress: {
                  success: 88.88888888888889,
                  error: 0,
                },
              },
              uid: "a0786a00-782e-461b-8a51-1a37754d7c8d",
              metavars: {
                "Book Title": 34,
                Author: 35,
                __pt: "What is the opening sentence of {book} by {author}?",
                LLM_0: "Llama 3.2 1B",
              },
            },
            {
              text: 33,
              prompt: 32,
              fill_history: {
                book: 34,
                author: 35,
              },
              llm: {
                key: "f7d40da2-ae54-4bc1-8c2b-8cc9c4596f1f",
                name: "Ministral 8B",
                emoji: "🌬️",
                model: "openrouter/mistralai/ministral-8b-2512",
                base_model: "openrouter",
                temp: 1,
                formData: {
                  shortname: "Ministral 8B",
                  model: "mistralai/ministral-8b-2512",
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: "text",
                  tools: "",
                  tool_choice: "",
                  top_p: 1,
                  stop: "",
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                settings: {
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: {
                    type: "text",
                  },
                  tools: [],
                  tool_choice: "",
                  top_p: 1,
                  stop: [],
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                progress: {
                  success: 100,
                  error: 0,
                },
              },
              uid: "ed530ca1-a0bc-45c6-a11e-d0d545fa8c3d",
              metavars: {
                "Book Title": 34,
                Author: 35,
                __pt: "What is the opening sentence of {book} by {author}?",
                LLM_0: "Ministral 8B",
              },
            },
            {
              text: 48,
              prompt: 32,
              fill_history: {
                book: 34,
                author: 35,
              },
              llm: {
                key: "bf327375-57f3-4683-8162-7db973c9aec1",
                name: "Qwen3 8B",
                emoji: "🐉",
                model: "openrouter/qwen/qwen3-8b",
                base_model: "openrouter",
                temp: 1,
                formData: {
                  shortname: "Qwen3 8B",
                  model: "qwen/qwen3-8b",
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: "text",
                  tools: "",
                  tool_choice: "",
                  top_p: 1,
                  stop: "",
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                settings: {
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: {
                    type: "text",
                  },
                  tools: [],
                  tool_choice: "",
                  top_p: 1,
                  stop: [],
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                progress: {
                  success: 100,
                  error: 0,
                },
              },
              uid: "68462ba8-a516-4bc3-bc6d-a583b969113e",
              metavars: {
                "Book Title": 34,
                Author: 35,
                __pt: "What is the opening sentence of {book} by {author}?",
                LLM_0: "Qwen3 8B",
              },
            },
            {
              text: 36,
              prompt: 32,
              fill_history: {
                book: 34,
                author: 35,
              },
              llm: {
                key: "db5f451f-16e2-4681-ad1d-6c7a421df309",
                name: "Gemma 4 31B",
                emoji: "♊",
                model: "openrouter/google/gemma-4-31b-it",
                base_model: "openrouter",
                temp: 1,
                formData: {
                  shortname: "Gemma 4 31B",
                  model: "google/gemma-4-31b-it",
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: "text",
                  tools: "",
                  tool_choice: "",
                  top_p: 1,
                  stop: "",
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                settings: {
                  system_msg: "You are a helpful assistant.",
                  temperature: 1,
                  reasoning_effort: "off",
                  reasoning_max_tokens: null,
                  response_format: {
                    type: "text",
                  },
                  tools: [],
                  tool_choice: "",
                  top_p: 1,
                  stop: [],
                  max_tokens: 400,
                  seed: null,
                  presence_penalty: 0,
                  frequency_penalty: 0,
                },
                progress: {
                  success: 100,
                  error: 0,
                },
              },
              uid: "aca65f14-ec49-49f7-bb32-0ca41142fcb3",
              metavars: {
                "Book Title": 34,
                Author: 35,
                __pt: "What is the opening sentence of {book} by {author}?",
                LLM_0: "Gemma 4 31B",
              },
            },
          ],
        },
        position: {
          x: 144,
          y: 128,
        },
        selected: false,
        positionAbsolute: {
          x: 144,
          y: 128,
        },
        dragging: false,
      },
      {
        width: 302,
        height: 323,
        id: "inspect-1687991312103",
        type: "inspect",
        data: {
          input: "prompt-1687991312103",
          refresh: false,
        },
        position: {
          x: 528,
          y: 192,
        },
        selected: true,
        positionAbsolute: {
          x: 528,
          y: 192,
        },
        dragging: false,
      },
      {
        width: 422,
        height: 446,
        id: "table-1735328737110",
        type: "table",
        data: {
          rows: [
            {
              __uid: "86e792e3-9eb0-4ee5-a592-d5913b111d7d",
              "col-0": "Pride and Prejudice",
              "col-1": "Jane Austen",
            },
            {
              __uid: "5449fc1f-0eef-44dc-b296-a1052293e765",
              "col-0": "The Secret History",
              "col-1": "Donna Tartt",
            },
            {
              __uid: "4e473ab1-7878-4dba-b02d-ac0864007840",
              "col-0": "Beloved",
              "col-1": "Toni Morrison",
            },
            {
              __uid: "9889f2d6-4f70-48d8-9d64-d346424c7499",
              "col-0": "Mistborn",
              "col-1": "Brandon Sanderson",
            },
            {
              __uid: "55cc52c7-4b40-4b79-939e-5076441e3107",
              "col-0": "The Poppy War",
              "col-1": "R.F. Kuang",
            },
            {
              __uid: "08872aef-5873-4c62-92b6-5e7be77ad954",
              "col-0": "Twilight",
              "col-1": "Stephenie Meyer",
            },
            {
              __uid: "d6c761cf-a65a-4019-ae21-3175a761f0a2",
              "col-0": "Crime and Punishment",
              "col-1": "Dostoevsky",
            },
            {
              __uid: "af88e315-69b6-4d95-a38a-adb37247f2fd",
              "col-0": "A Wrinkle in Time",
              "col-1": "Madeleine L'Engle",
            },
            {
              __uid: "9616dd9e-f902-4f2a-9326-4613370fd94c",
              "col-0": "The Stranger",
              "col-1": "Albert Camus",
            },
          ],
          columns: [
            {
              header: "Book Title",
              key: "col-0",
            },
            {
              header: "Author",
              key: "col-1",
            },
          ],
          sel_rows: null,
        },
        position: {
          x: -368,
          y: 128,
        },
        selected: false,
        positionAbsolute: {
          x: -368,
          y: 128,
        },
        dragging: false,
      },
    ],
    edges: [
      {
        source: "prompt-1687991312103",
        sourceHandle: "prompt",
        target: "inspect-1687991312103",
        targetHandle: "input",
        interactionWidth: 100,
        markerEnd: {
          type: "arrow",
          width: "22px",
          height: "22px",
        },
        id: "reactflow__edge-prompt-1687991312103prompt-inspect-1687991312103input",
      },
      {
        source: "table-1735328737110",
        sourceHandle: "Book Title",
        target: "prompt-1687991312103",
        targetHandle: "book",
        interactionWidth: 40,
        markerEnd: {
          type: "arrow",
          width: 22,
          height: 22,
        },
        type: "default",
        id: "reactflow__edge-table-1735328737110Book Title-prompt-1687991312103book",
      },
      {
        source: "table-1735328737110",
        sourceHandle: "Author",
        target: "prompt-1687991312103",
        targetHandle: "author",
        interactionWidth: 40,
        markerEnd: {
          type: "arrow",
          width: 22,
          height: 22,
        },
        type: "default",
        id: "reactflow__edge-table-1735328737110Author-prompt-1687991312103author",
      },
    ],
    viewport: {
      x: 535,
      y: 91,
      zoom: 1,
    },
  },
  cache: {
    "prompt-1687991312103_0.json": {
      "What is the opening sentence of Twilight by Stephenie Meyer?": [
        {
          prompt: 28,
          uid: "a532566a-8de2-4572-8e72-02091d55884f",
          responses: [47],
          llm: "Llama 3.2 1B",
          vars: {
            book: 30,
            author: 31,
          },
          metavars: {
            "Book Title": 30,
            Author: 31,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Llama 3.2 1B",
          },
        },
      ],
      "What is the opening sentence of A Wrinkle in Time by Madeleine L'Engle?":
        [
          {
            prompt: 20,
            uid: "62e000b3-3257-4d6e-b556-e14e0502a6ed",
            responses: [53],
            llm: "Llama 3.2 1B",
            vars: {
              book: 22,
              author: 23,
            },
            metavars: {
              "Book Title": 22,
              Author: 23,
              __pt: "What is the opening sentence of {book} by {author}?",
              LLM_0: "Llama 3.2 1B",
            },
          },
        ],
      "What is the opening sentence of Pride and Prejudice by Jane Austen?": [
        {
          prompt: 8,
          uid: "2ad09d4a-911b-4548-81f9-d397b8d12c00",
          responses: [55],
          llm: "Llama 3.2 1B",
          vars: {
            book: 10,
            author: 11,
          },
          metavars: {
            "Book Title": 10,
            Author: 11,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Llama 3.2 1B",
          },
        },
      ],
      "What is the opening sentence of Mistborn by Brandon Sanderson?": [
        {
          prompt: 12,
          uid: "d82f4517-721a-4cba-9729-55b1f2ad02b5",
          responses: [56],
          llm: "Llama 3.2 1B",
          vars: {
            book: 14,
            author: 15,
          },
          metavars: {
            "Book Title": 14,
            Author: 15,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Llama 3.2 1B",
          },
        },
      ],
      "What is the opening sentence of Beloved by Toni Morrison?": [
        {
          prompt: 0,
          uid: "3979ba3b-fe27-4693-b372-ad5882fe2ff9",
          responses: [57],
          llm: "Llama 3.2 1B",
          vars: {
            book: 2,
            author: 3,
          },
          metavars: {
            "Book Title": 2,
            Author: 3,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Llama 3.2 1B",
          },
        },
      ],
      "What is the opening sentence of The Secret History by Donna Tartt?": [
        {
          prompt: 16,
          uid: "441c8527-439d-400c-ac7d-e9fbdede390f",
          responses: [58],
          llm: "Llama 3.2 1B",
          vars: {
            book: 18,
            author: 19,
          },
          metavars: {
            "Book Title": 18,
            Author: 19,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Llama 3.2 1B",
          },
        },
      ],
      "What is the opening sentence of The Poppy War by R.F. Kuang?": [
        {
          prompt: 4,
          uid: "b7014ea7-efa0-4e6f-aa72-a7e938b909b9",
          responses: [59],
          llm: "Llama 3.2 1B",
          vars: {
            book: 6,
            author: 7,
          },
          metavars: {
            "Book Title": 6,
            Author: 7,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Llama 3.2 1B",
          },
        },
      ],
      "What is the opening sentence of The Stranger by Albert Camus?": [
        {
          prompt: 32,
          uid: "a0786a00-782e-461b-8a51-1a37754d7c8d",
          responses: [60],
          llm: "Llama 3.2 1B",
          vars: {
            book: 34,
            author: 35,
          },
          metavars: {
            "Book Title": 34,
            Author: 35,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Llama 3.2 1B",
          },
        },
      ],
      "What is the opening sentence of Crime and Punishment by Dostoevsky?": [
        {
          prompt: 24,
          uid: "22c6d341-9f01-4186-be96-927311830115",
          responses: [61],
          llm: "Llama 3.2 1B",
          vars: {
            book: 26,
            author: 27,
          },
          metavars: {
            "Book Title": 26,
            Author: 27,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Llama 3.2 1B",
          },
        },
      ],
    },
    "prompt-1687991312103_1.json": {
      "What is the opening sentence of Beloved by Toni Morrison?": [
        {
          prompt: 0,
          uid: "55622b27-476c-44d8-9377-2ae07ed2e714",
          responses: [1],
          llm: "Ministral 8B",
          vars: {
            book: 2,
            author: 3,
          },
          metavars: {
            "Book Title": 2,
            Author: 3,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Ministral 8B",
          },
        },
      ],
      "What is the opening sentence of The Poppy War by R.F. Kuang?": [
        {
          prompt: 4,
          uid: "a52cb924-25c3-464a-b6ca-843d3c7a3d5f",
          responses: [5],
          llm: "Ministral 8B",
          vars: {
            book: 6,
            author: 7,
          },
          metavars: {
            "Book Title": 6,
            Author: 7,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Ministral 8B",
          },
        },
      ],
      "What is the opening sentence of Pride and Prejudice by Jane Austen?": [
        {
          prompt: 8,
          uid: "91999795-4ac0-48ab-b79b-d9e49aab946a",
          responses: [9],
          llm: "Ministral 8B",
          vars: {
            book: 10,
            author: 11,
          },
          metavars: {
            "Book Title": 10,
            Author: 11,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Ministral 8B",
          },
        },
      ],
      "What is the opening sentence of Mistborn by Brandon Sanderson?": [
        {
          prompt: 12,
          uid: "2a946b37-8052-44e7-b3b0-67e1165846f8",
          responses: [13],
          llm: "Ministral 8B",
          vars: {
            book: 14,
            author: 15,
          },
          metavars: {
            "Book Title": 14,
            Author: 15,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Ministral 8B",
          },
        },
      ],
      "What is the opening sentence of The Secret History by Donna Tartt?": [
        {
          prompt: 16,
          uid: "da19f46b-1af1-4bad-9659-20051df12c2d",
          responses: [17],
          llm: "Ministral 8B",
          vars: {
            book: 18,
            author: 19,
          },
          metavars: {
            "Book Title": 18,
            Author: 19,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Ministral 8B",
          },
        },
      ],
      "What is the opening sentence of A Wrinkle in Time by Madeleine L'Engle?":
        [
          {
            prompt: 20,
            uid: "ccefccf7-7446-4a42-94ee-edc2e76c5a0a",
            responses: [21],
            llm: "Ministral 8B",
            vars: {
              book: 22,
              author: 23,
            },
            metavars: {
              "Book Title": 22,
              Author: 23,
              __pt: "What is the opening sentence of {book} by {author}?",
              LLM_0: "Ministral 8B",
            },
          },
        ],
      "What is the opening sentence of Crime and Punishment by Dostoevsky?": [
        {
          prompt: 24,
          uid: "b7f119b5-5478-4d9c-8cfe-10d31a1a3686",
          responses: [25],
          llm: "Ministral 8B",
          vars: {
            book: 26,
            author: 27,
          },
          metavars: {
            "Book Title": 26,
            Author: 27,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Ministral 8B",
          },
        },
      ],
      "What is the opening sentence of Twilight by Stephenie Meyer?": [
        {
          prompt: 28,
          uid: "6d02bca3-2193-4234-9bc0-fb01c9f77710",
          responses: [29],
          llm: "Ministral 8B",
          vars: {
            book: 30,
            author: 31,
          },
          metavars: {
            "Book Title": 30,
            Author: 31,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Ministral 8B",
          },
        },
      ],
      "What is the opening sentence of The Stranger by Albert Camus?": [
        {
          prompt: 32,
          uid: "ed530ca1-a0bc-45c6-a11e-d0d545fa8c3d",
          responses: [33],
          llm: "Ministral 8B",
          vars: {
            book: 34,
            author: 35,
          },
          metavars: {
            "Book Title": 34,
            Author: 35,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Ministral 8B",
          },
        },
      ],
    },
    "prompt-1687991312103_2.json": {
      "What is the opening sentence of Beloved by Toni Morrison?": [
        {
          prompt: 0,
          uid: "8c972ed8-0d89-4040-9bfd-19e75e036368",
          responses: [37],
          llm: "Qwen3 8B",
          vars: {
            book: 2,
            author: 3,
          },
          metavars: {
            "Book Title": 2,
            Author: 3,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Qwen3 8B",
          },
        },
      ],
      "What is the opening sentence of The Secret History by Donna Tartt?": [
        {
          prompt: 16,
          uid: "a252e69f-5b82-4d3f-b6c1-7725fe33a6e4",
          responses: [38],
          llm: "Qwen3 8B",
          vars: {
            book: 18,
            author: 19,
          },
          metavars: {
            "Book Title": 18,
            Author: 19,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Qwen3 8B",
          },
        },
      ],
      "What is the opening sentence of Pride and Prejudice by Jane Austen?": [
        {
          prompt: 8,
          uid: "b16c6ce6-b029-4e87-a707-47a6caaad9e9",
          responses: [9],
          llm: "Qwen3 8B",
          vars: {
            book: 10,
            author: 11,
          },
          metavars: {
            "Book Title": 10,
            Author: 11,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Qwen3 8B",
          },
        },
      ],
      "What is the opening sentence of Twilight by Stephenie Meyer?": [
        {
          prompt: 28,
          uid: "e294af6a-21b3-4e07-9c09-d3e13017514b",
          responses: [40],
          llm: "Qwen3 8B",
          vars: {
            book: 30,
            author: 31,
          },
          metavars: {
            "Book Title": 30,
            Author: 31,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Qwen3 8B",
          },
        },
      ],
      "What is the opening sentence of The Poppy War by R.F. Kuang?": [
        {
          prompt: 4,
          uid: "4bcad951-06f8-4814-bd57-405791fc982c",
          responses: [42],
          llm: "Qwen3 8B",
          vars: {
            book: 6,
            author: 7,
          },
          metavars: {
            "Book Title": 6,
            Author: 7,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Qwen3 8B",
          },
        },
      ],
      "What is the opening sentence of Mistborn by Brandon Sanderson?": [
        {
          prompt: 12,
          uid: "539eba74-9656-4209-9f40-db37870d62e4",
          responses: [43],
          llm: "Qwen3 8B",
          vars: {
            book: 14,
            author: 15,
          },
          metavars: {
            "Book Title": 14,
            Author: 15,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Qwen3 8B",
          },
        },
      ],
      "What is the opening sentence of The Stranger by Albert Camus?": [
        {
          prompt: 32,
          uid: "68462ba8-a516-4bc3-bc6d-a583b969113e",
          responses: [48],
          llm: "Qwen3 8B",
          vars: {
            book: 34,
            author: 35,
          },
          metavars: {
            "Book Title": 34,
            Author: 35,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Qwen3 8B",
          },
        },
      ],
      "What is the opening sentence of A Wrinkle in Time by Madeleine L'Engle?":
        [
          {
            prompt: 20,
            uid: "f0893573-fa42-4b0a-bf15-24ffee06e540",
            responses: [49],
            llm: "Qwen3 8B",
            vars: {
              book: 22,
              author: 23,
            },
            metavars: {
              "Book Title": 22,
              Author: 23,
              __pt: "What is the opening sentence of {book} by {author}?",
              LLM_0: "Qwen3 8B",
            },
          },
        ],
      "What is the opening sentence of Crime and Punishment by Dostoevsky?": [
        {
          prompt: 24,
          uid: "593fa71f-7be1-42f1-a27c-3b8e681d5a67",
          responses: [50],
          llm: "Qwen3 8B",
          vars: {
            book: 26,
            author: 27,
          },
          metavars: {
            "Book Title": 26,
            Author: 27,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Qwen3 8B",
          },
        },
      ],
    },
    "prompt-1687991312103_3.json": {
      "What is the opening sentence of The Stranger by Albert Camus?": [
        {
          prompt: 32,
          uid: "aca65f14-ec49-49f7-bb32-0ca41142fcb3",
          responses: [36],
          llm: "Gemma 4 31B",
          vars: {
            book: 34,
            author: 35,
          },
          metavars: {
            "Book Title": 34,
            Author: 35,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Gemma 4 31B",
          },
        },
      ],
      "What is the opening sentence of A Wrinkle in Time by Madeleine L'Engle?":
        [
          {
            prompt: 20,
            uid: "06343fe1-e70e-406d-8e0f-70231e835afa",
            responses: [39],
            llm: "Gemma 4 31B",
            vars: {
              book: 22,
              author: 23,
            },
            metavars: {
              "Book Title": 22,
              Author: 23,
              __pt: "What is the opening sentence of {book} by {author}?",
              LLM_0: "Gemma 4 31B",
            },
          },
        ],
      "What is the opening sentence of The Secret History by Donna Tartt?": [
        {
          prompt: 16,
          uid: "c8d13d82-81ba-4168-849f-41ff0c3e2d4c",
          responses: [41],
          llm: "Gemma 4 31B",
          vars: {
            book: 18,
            author: 19,
          },
          metavars: {
            "Book Title": 18,
            Author: 19,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Gemma 4 31B",
          },
        },
      ],
      "What is the opening sentence of Mistborn by Brandon Sanderson?": [
        {
          prompt: 12,
          uid: "e65eef41-eb19-470c-8d69-fb1e5806b0fd",
          responses: [44],
          llm: "Gemma 4 31B",
          vars: {
            book: 14,
            author: 15,
          },
          metavars: {
            "Book Title": 14,
            Author: 15,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Gemma 4 31B",
          },
        },
      ],
      "What is the opening sentence of Pride and Prejudice by Jane Austen?": [
        {
          prompt: 8,
          uid: "c879cec0-3649-4b87-a414-2d005f1bb2a2",
          responses: [45],
          llm: "Gemma 4 31B",
          vars: {
            book: 10,
            author: 11,
          },
          metavars: {
            "Book Title": 10,
            Author: 11,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Gemma 4 31B",
          },
        },
      ],
      "What is the opening sentence of Crime and Punishment by Dostoevsky?": [
        {
          prompt: 24,
          uid: "717c4c08-1411-433b-a505-6f7ec091c3cb",
          responses: [46],
          llm: "Gemma 4 31B",
          vars: {
            book: 26,
            author: 27,
          },
          metavars: {
            "Book Title": 26,
            Author: 27,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Gemma 4 31B",
          },
        },
      ],
      "What is the opening sentence of Beloved by Toni Morrison?": [
        {
          prompt: 0,
          uid: "ea3849d6-887b-4772-8c1e-c892c610bd0c",
          responses: [51],
          llm: "Gemma 4 31B",
          vars: {
            book: 2,
            author: 3,
          },
          metavars: {
            "Book Title": 2,
            Author: 3,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Gemma 4 31B",
          },
        },
      ],
      "What is the opening sentence of The Poppy War by R.F. Kuang?": [
        {
          prompt: 4,
          uid: "58a14690-8b11-4a2f-895a-4de16a79d272",
          responses: [52],
          llm: "Gemma 4 31B",
          vars: {
            book: 6,
            author: 7,
          },
          metavars: {
            "Book Title": 6,
            Author: 7,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Gemma 4 31B",
          },
        },
      ],
      "What is the opening sentence of Twilight by Stephenie Meyer?": [
        {
          prompt: 28,
          uid: "8c5bfb7e-0abe-4a5d-8f44-da34ab71eada",
          responses: [54],
          llm: "Gemma 4 31B",
          vars: {
            book: 30,
            author: 31,
          },
          metavars: {
            "Book Title": 30,
            Author: 31,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Gemma 4 31B",
          },
        },
      ],
    },
    "prompt-1687991312103.json": {
      cache_files: {
        "prompt-1687991312103_0.json": {
          key: "67b1b7c0-1594-4dac-b705-d6804ad0b96f",
          name: "Llama 3.2 1B",
          emoji: "🦙",
          model: "openrouter/meta-llama/llama-3.2-1b-instruct",
          base_model: "openrouter",
          temp: 1,
          formData: {
            shortname: "Llama 3.2 1B",
            model: "meta-llama/llama-3.2-1b-instruct",
            system_msg: "You are a helpful assistant.",
            temperature: 1,
            reasoning_effort: "off",
            reasoning_max_tokens: null,
            response_format: "text",
            tools: "",
            tool_choice: "",
            top_p: 1,
            stop: "",
            max_tokens: 400,
            seed: null,
            presence_penalty: 0,
            frequency_penalty: 0,
          },
          settings: {
            system_msg: "You are a helpful assistant.",
            temperature: 1,
            reasoning_effort: "off",
            reasoning_max_tokens: null,
            response_format: {
              type: "text",
            },
            tools: [],
            tool_choice: "",
            top_p: 1,
            stop: [],
            max_tokens: 400,
            seed: null,
            presence_penalty: 0,
            frequency_penalty: 0,
          },
          progress: {
            success: 0,
            error: 0,
          },
        },
        "prompt-1687991312103_1.json": {
          key: "f7d40da2-ae54-4bc1-8c2b-8cc9c4596f1f",
          name: "Ministral 8B",
          emoji: "🌬️",
          model: "openrouter/mistralai/ministral-8b-2512",
          base_model: "openrouter",
          temp: 1,
          formData: {
            shortname: "Ministral 8B",
            model: "mistralai/ministral-8b-2512",
            system_msg: "You are a helpful assistant.",
            temperature: 1,
            reasoning_effort: "off",
            reasoning_max_tokens: null,
            response_format: "text",
            tools: "",
            tool_choice: "",
            top_p: 1,
            stop: "",
            max_tokens: 400,
            seed: null,
            presence_penalty: 0,
            frequency_penalty: 0,
          },
          settings: {
            system_msg: "You are a helpful assistant.",
            temperature: 1,
            reasoning_effort: "off",
            reasoning_max_tokens: null,
            response_format: {
              type: "text",
            },
            tools: [],
            tool_choice: "",
            top_p: 1,
            stop: [],
            max_tokens: 400,
            seed: null,
            presence_penalty: 0,
            frequency_penalty: 0,
          },
          progress: {
            success: 0,
            error: 0,
          },
        },
        "prompt-1687991312103_2.json": {
          key: "bf327375-57f3-4683-8162-7db973c9aec1",
          name: "Qwen3 8B",
          emoji: "🐉",
          model: "openrouter/qwen/qwen3-8b",
          base_model: "openrouter",
          temp: 1,
          formData: {
            shortname: "Qwen3 8B",
            model: "qwen/qwen3-8b",
            system_msg: "You are a helpful assistant.",
            temperature: 1,
            reasoning_effort: "off",
            reasoning_max_tokens: null,
            response_format: "text",
            tools: "",
            tool_choice: "",
            top_p: 1,
            stop: "",
            max_tokens: 400,
            seed: null,
            presence_penalty: 0,
            frequency_penalty: 0,
          },
          settings: {
            system_msg: "You are a helpful assistant.",
            temperature: 1,
            reasoning_effort: "off",
            reasoning_max_tokens: null,
            response_format: {
              type: "text",
            },
            tools: [],
            tool_choice: "",
            top_p: 1,
            stop: [],
            max_tokens: 400,
            seed: null,
            presence_penalty: 0,
            frequency_penalty: 0,
          },
          progress: {
            success: 0,
            error: 0,
          },
        },
        "prompt-1687991312103_3.json": {
          key: "db5f451f-16e2-4681-ad1d-6c7a421df309",
          name: "Gemma 4 31B",
          emoji: "♊",
          model: "openrouter/google/gemma-4-31b-it",
          base_model: "openrouter",
          temp: 1,
          formData: {
            shortname: "Gemma 4 31B",
            model: "google/gemma-4-31b-it",
            system_msg: "You are a helpful assistant.",
            temperature: 1,
            reasoning_effort: "off",
            reasoning_max_tokens: null,
            response_format: "text",
            tools: "",
            tool_choice: "",
            top_p: 1,
            stop: "",
            max_tokens: 400,
            seed: null,
            presence_penalty: 0,
            frequency_penalty: 0,
          },
          settings: {
            system_msg: "You are a helpful assistant.",
            temperature: 1,
            reasoning_effort: "off",
            reasoning_max_tokens: null,
            response_format: {
              type: "text",
            },
            tools: [],
            tool_choice: "",
            top_p: 1,
            stop: [],
            max_tokens: 400,
            seed: null,
            presence_penalty: 0,
            frequency_penalty: 0,
          },
          progress: {
            success: 0,
            error: 0,
          },
        },
      },
      responses_last_run: [
        {
          vars: {
            book: 10,
            author: 11,
          },
          metavars: {
            "Book Title": 10,
            Author: 11,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Llama 3.2 1B",
          },
          llm: "Llama 3.2 1B",
          prompt: 8,
          responses: [55],
          uid: "2ad09d4a-911b-4548-81f9-d397b8d12c00",
        },
        {
          vars: {
            book: 10,
            author: 11,
          },
          metavars: {
            "Book Title": 10,
            Author: 11,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Ministral 8B",
          },
          llm: "Ministral 8B",
          prompt: 8,
          responses: [9],
          uid: "91999795-4ac0-48ab-b79b-d9e49aab946a",
        },
        {
          vars: {
            book: 10,
            author: 11,
          },
          metavars: {
            "Book Title": 10,
            Author: 11,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Qwen3 8B",
          },
          llm: "Qwen3 8B",
          prompt: 8,
          responses: [9],
          uid: "b16c6ce6-b029-4e87-a707-47a6caaad9e9",
        },
        {
          vars: {
            book: 10,
            author: 11,
          },
          metavars: {
            "Book Title": 10,
            Author: 11,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Gemma 4 31B",
          },
          llm: "Gemma 4 31B",
          prompt: 8,
          responses: [45],
          uid: "c879cec0-3649-4b87-a414-2d005f1bb2a2",
        },
        {
          vars: {
            book: 18,
            author: 19,
          },
          metavars: {
            "Book Title": 18,
            Author: 19,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Llama 3.2 1B",
          },
          llm: "Llama 3.2 1B",
          prompt: 16,
          responses: [58],
          uid: "441c8527-439d-400c-ac7d-e9fbdede390f",
        },
        {
          vars: {
            book: 18,
            author: 19,
          },
          metavars: {
            "Book Title": 18,
            Author: 19,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Ministral 8B",
          },
          llm: "Ministral 8B",
          prompt: 16,
          responses: [17],
          uid: "da19f46b-1af1-4bad-9659-20051df12c2d",
        },
        {
          vars: {
            book: 18,
            author: 19,
          },
          metavars: {
            "Book Title": 18,
            Author: 19,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Qwen3 8B",
          },
          llm: "Qwen3 8B",
          prompt: 16,
          responses: [38],
          uid: "a252e69f-5b82-4d3f-b6c1-7725fe33a6e4",
        },
        {
          vars: {
            book: 18,
            author: 19,
          },
          metavars: {
            "Book Title": 18,
            Author: 19,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Gemma 4 31B",
          },
          llm: "Gemma 4 31B",
          prompt: 16,
          responses: [41],
          uid: "c8d13d82-81ba-4168-849f-41ff0c3e2d4c",
        },
        {
          vars: {
            book: 2,
            author: 3,
          },
          metavars: {
            "Book Title": 2,
            Author: 3,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Llama 3.2 1B",
          },
          llm: "Llama 3.2 1B",
          prompt: 0,
          responses: [57],
          uid: "3979ba3b-fe27-4693-b372-ad5882fe2ff9",
        },
        {
          vars: {
            book: 2,
            author: 3,
          },
          metavars: {
            "Book Title": 2,
            Author: 3,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Ministral 8B",
          },
          llm: "Ministral 8B",
          prompt: 0,
          responses: [1],
          uid: "55622b27-476c-44d8-9377-2ae07ed2e714",
        },
        {
          vars: {
            book: 2,
            author: 3,
          },
          metavars: {
            "Book Title": 2,
            Author: 3,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Qwen3 8B",
          },
          llm: "Qwen3 8B",
          prompt: 0,
          responses: [37],
          uid: "8c972ed8-0d89-4040-9bfd-19e75e036368",
        },
        {
          vars: {
            book: 2,
            author: 3,
          },
          metavars: {
            "Book Title": 2,
            Author: 3,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Gemma 4 31B",
          },
          llm: "Gemma 4 31B",
          prompt: 0,
          responses: [51],
          uid: "ea3849d6-887b-4772-8c1e-c892c610bd0c",
        },
        {
          vars: {
            book: 14,
            author: 15,
          },
          metavars: {
            "Book Title": 14,
            Author: 15,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Llama 3.2 1B",
          },
          llm: "Llama 3.2 1B",
          prompt: 12,
          responses: [56],
          uid: "d82f4517-721a-4cba-9729-55b1f2ad02b5",
        },
        {
          vars: {
            book: 14,
            author: 15,
          },
          metavars: {
            "Book Title": 14,
            Author: 15,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Ministral 8B",
          },
          llm: "Ministral 8B",
          prompt: 12,
          responses: [13],
          uid: "2a946b37-8052-44e7-b3b0-67e1165846f8",
        },
        {
          vars: {
            book: 14,
            author: 15,
          },
          metavars: {
            "Book Title": 14,
            Author: 15,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Qwen3 8B",
          },
          llm: "Qwen3 8B",
          prompt: 12,
          responses: [43],
          uid: "539eba74-9656-4209-9f40-db37870d62e4",
        },
        {
          vars: {
            book: 14,
            author: 15,
          },
          metavars: {
            "Book Title": 14,
            Author: 15,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Gemma 4 31B",
          },
          llm: "Gemma 4 31B",
          prompt: 12,
          responses: [44],
          uid: "e65eef41-eb19-470c-8d69-fb1e5806b0fd",
        },
        {
          vars: {
            book: 6,
            author: 7,
          },
          metavars: {
            "Book Title": 6,
            Author: 7,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Llama 3.2 1B",
          },
          llm: "Llama 3.2 1B",
          prompt: 4,
          responses: [59],
          uid: "b7014ea7-efa0-4e6f-aa72-a7e938b909b9",
        },
        {
          vars: {
            book: 6,
            author: 7,
          },
          metavars: {
            "Book Title": 6,
            Author: 7,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Ministral 8B",
          },
          llm: "Ministral 8B",
          prompt: 4,
          responses: [5],
          uid: "a52cb924-25c3-464a-b6ca-843d3c7a3d5f",
        },
        {
          vars: {
            book: 6,
            author: 7,
          },
          metavars: {
            "Book Title": 6,
            Author: 7,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Qwen3 8B",
          },
          llm: "Qwen3 8B",
          prompt: 4,
          responses: [42],
          uid: "4bcad951-06f8-4814-bd57-405791fc982c",
        },
        {
          vars: {
            book: 6,
            author: 7,
          },
          metavars: {
            "Book Title": 6,
            Author: 7,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Gemma 4 31B",
          },
          llm: "Gemma 4 31B",
          prompt: 4,
          responses: [52],
          uid: "58a14690-8b11-4a2f-895a-4de16a79d272",
        },
        {
          vars: {
            book: 30,
            author: 31,
          },
          metavars: {
            "Book Title": 30,
            Author: 31,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Llama 3.2 1B",
          },
          llm: "Llama 3.2 1B",
          prompt: 28,
          responses: [47],
          uid: "a532566a-8de2-4572-8e72-02091d55884f",
        },
        {
          vars: {
            book: 30,
            author: 31,
          },
          metavars: {
            "Book Title": 30,
            Author: 31,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Ministral 8B",
          },
          llm: "Ministral 8B",
          prompt: 28,
          responses: [29],
          uid: "6d02bca3-2193-4234-9bc0-fb01c9f77710",
        },
        {
          vars: {
            book: 30,
            author: 31,
          },
          metavars: {
            "Book Title": 30,
            Author: 31,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Qwen3 8B",
          },
          llm: "Qwen3 8B",
          prompt: 28,
          responses: [40],
          uid: "e294af6a-21b3-4e07-9c09-d3e13017514b",
        },
        {
          vars: {
            book: 30,
            author: 31,
          },
          metavars: {
            "Book Title": 30,
            Author: 31,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Gemma 4 31B",
          },
          llm: "Gemma 4 31B",
          prompt: 28,
          responses: [54],
          uid: "8c5bfb7e-0abe-4a5d-8f44-da34ab71eada",
        },
        {
          vars: {
            book: 26,
            author: 27,
          },
          metavars: {
            "Book Title": 26,
            Author: 27,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Llama 3.2 1B",
          },
          llm: "Llama 3.2 1B",
          prompt: 24,
          responses: [61],
          uid: "22c6d341-9f01-4186-be96-927311830115",
        },
        {
          vars: {
            book: 26,
            author: 27,
          },
          metavars: {
            "Book Title": 26,
            Author: 27,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Ministral 8B",
          },
          llm: "Ministral 8B",
          prompt: 24,
          responses: [25],
          uid: "b7f119b5-5478-4d9c-8cfe-10d31a1a3686",
        },
        {
          vars: {
            book: 26,
            author: 27,
          },
          metavars: {
            "Book Title": 26,
            Author: 27,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Qwen3 8B",
          },
          llm: "Qwen3 8B",
          prompt: 24,
          responses: [50],
          uid: "593fa71f-7be1-42f1-a27c-3b8e681d5a67",
        },
        {
          vars: {
            book: 26,
            author: 27,
          },
          metavars: {
            "Book Title": 26,
            Author: 27,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Gemma 4 31B",
          },
          llm: "Gemma 4 31B",
          prompt: 24,
          responses: [46],
          uid: "717c4c08-1411-433b-a505-6f7ec091c3cb",
        },
        {
          vars: {
            book: 22,
            author: 23,
          },
          metavars: {
            "Book Title": 22,
            Author: 23,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Llama 3.2 1B",
          },
          llm: "Llama 3.2 1B",
          prompt: 20,
          responses: [53],
          uid: "62e000b3-3257-4d6e-b556-e14e0502a6ed",
        },
        {
          vars: {
            book: 22,
            author: 23,
          },
          metavars: {
            "Book Title": 22,
            Author: 23,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Ministral 8B",
          },
          llm: "Ministral 8B",
          prompt: 20,
          responses: [21],
          uid: "ccefccf7-7446-4a42-94ee-edc2e76c5a0a",
        },
        {
          vars: {
            book: 22,
            author: 23,
          },
          metavars: {
            "Book Title": 22,
            Author: 23,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Qwen3 8B",
          },
          llm: "Qwen3 8B",
          prompt: 20,
          responses: [49],
          uid: "f0893573-fa42-4b0a-bf15-24ffee06e540",
        },
        {
          vars: {
            book: 22,
            author: 23,
          },
          metavars: {
            "Book Title": 22,
            Author: 23,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Gemma 4 31B",
          },
          llm: "Gemma 4 31B",
          prompt: 20,
          responses: [39],
          uid: "06343fe1-e70e-406d-8e0f-70231e835afa",
        },
        {
          vars: {
            book: 34,
            author: 35,
          },
          metavars: {
            "Book Title": 34,
            Author: 35,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Llama 3.2 1B",
          },
          llm: "Llama 3.2 1B",
          prompt: 32,
          responses: [60],
          uid: "a0786a00-782e-461b-8a51-1a37754d7c8d",
        },
        {
          vars: {
            book: 34,
            author: 35,
          },
          metavars: {
            "Book Title": 34,
            Author: 35,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Ministral 8B",
          },
          llm: "Ministral 8B",
          prompt: 32,
          responses: [33],
          uid: "ed530ca1-a0bc-45c6-a11e-d0d545fa8c3d",
        },
        {
          vars: {
            book: 34,
            author: 35,
          },
          metavars: {
            "Book Title": 34,
            Author: 35,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Qwen3 8B",
          },
          llm: "Qwen3 8B",
          prompt: 32,
          responses: [48],
          uid: "68462ba8-a516-4bc3-bc6d-a583b969113e",
        },
        {
          vars: {
            book: 34,
            author: 35,
          },
          metavars: {
            "Book Title": 34,
            Author: 35,
            __pt: "What is the opening sentence of {book} by {author}?",
            LLM_0: "Gemma 4 31B",
          },
          llm: "Gemma 4 31B",
          prompt: 32,
          responses: [36],
          uid: "aca65f14-ec49-49f7-bb32-0ca41142fcb3",
        },
      ],
    },
    "inspect-1687991312103.json": {},
    "table-1735328737110.json": {},
    __s: [
      "What is the opening sentence of Beloved by Toni Morrison?",
      'The opening sentence of *Beloved* by Toni Morrison is:\n\n**"124 was spiteful. Full of a baby’s venom."**',
      "Beloved",
      "Toni Morrison",
      "What is the opening sentence of The Poppy War by R.F. Kuang?",
      'The opening sentence of *The Poppy War* by **R.F. Kuang** is:\n\n*"The first time I saw the dead, I was eight years old."*',
      "The Poppy War",
      "R.F. Kuang",
      "What is the opening sentence of Pride and Prejudice by Jane Austen?",
      'The opening sentence of *Pride and Prejudice* by Jane Austen is:\n\n**"It is a truth universally acknowledged, that a single man in possession of a good fortune, must be in want of a wife."**',
      "Pride and Prejudice",
      "Jane Austen",
      "What is the opening sentence of Mistborn by Brandon Sanderson?",
      'The opening sentence of *Mistborn: The Final Empire* by Brandon Sanderson is:\n\n**"The city was dying."**\n\n*(From Chapter 1, "The Last Emperor")*',
      "Mistborn",
      "Brandon Sanderson",
      "What is the opening sentence of The Secret History by Donna Tartt?",
      'The opening sentence of *The Secret History* by Donna Tartt is:\n\n**"The snow fell steadily that night, blanketing the world in white and making the world seem a softer, gentler place."**',
      "The Secret History",
      "Donna Tartt",
      "What is the opening sentence of A Wrinkle in Time by Madeleine L'Engle?",
      'The opening sentence of *A Wrinkle in Time* by Madeleine L\'Engle is:\n\n**"It was a dark and starry night, and Meg Murry was sitting on the side of the hill watching her father."**',
      "A Wrinkle in Time",
      "Madeleine L'Engle",
      "What is the opening sentence of Crime and Punishment by Dostoevsky?",
      'The opening sentence of *Crime and Punishment* (1866) by Fyodor Dostoevsky is:\n\n**"An extraordinary mental torment was raging within Raskolnikov."**\n\n*(Original Russian: «В душе его разыгрывалась необыкновенная драма.»)*',
      "Crime and Punishment",
      "Dostoevsky",
      "What is the opening sentence of Twilight by Stephenie Meyer?",
      'The opening sentence of *Twilight* by Stephenie Meyer is:\n\n**"This is my favorite book in the world, and it is about me. I know that’s not possible, but please hear me out."**\n\n*(This is said by the narrator, Bella Swan, in the prologue.)*',
      "Twilight",
      "Stephenie Meyer",
      "What is the opening sentence of The Stranger by Albert Camus?",
      'The opening sentence of *The Stranger* (1942) by Albert Camus is:\n\n**"Aujourd’hui, maman est morte. Ou peut-être hier, je ne sais pas."**\n\nIn English, it translates to:\n\n**"Mother died today. Or maybe yesterday, I don’t know."**',
      "The Stranger",
      "Albert Camus",
      'The opening sentence of *The Stranger* (translated from the French *L\'Étranger*) is:\n\n**"Mother died today."**\n\n(Note: Depending on the translation, it may also appear as **"Maman died today."**)',
      'The opening sentence of *Beloved* by Toni Morrison is:\n\n**"1. Twelve years a slave. Twelve years a slave. Twelve years a slave."**',
      'The opening sentence of *The Secret History* by Donna Tartt is:\n\n**"The first time I met the boys, I was twelve and they were seventeen."**',
      'The opening sentence of *A Wrinkle in Time* is:\n\n**"It was a dark and stormy night."**',
      'The opening sentence of *Twilight* by Stephenie Meyer is:\n\n**"I found you."**',
      'The opening sentence of *The Secret History* by Donna Tartt is:\n\n"The acceptance of luck in a la place of fate is the first step toward madness."\n\n**Wait, I apologize—that is a common misquotation/confusion.** \n\nThe actual opening sentence of the novel is:\n\n**"The snow in the highlands turned a blinding white over night."**',
      'The opening sentence of *The Poppy War* by R.F. Kuang is:\n\n**"The first time I saw a dead man, I was ten years old."**',
      'The opening sentence of *Mistborn* by Brandon Sanderson is:\n\n**"I was born on a night when the moon was dark."**',
      'The opening sentence of *Mistborn: The Final Empire* is:\n\n**"The ash fell softly on the city, a grey blanket that muffled the sounds of the street."**',
      'The opening sentence of *Pride and Prejudice* is:\n\n"It is a truth universally acknowledged, that a single man in possession of a good fortune, must be in want of a wife."',
      'The opening sentence of *Crime and Punishment* depends on the translation, but the most widely recognized English version (by Constance Garnett) is:\n\n**"In early July, during the own hottest days, when few carriages a day happened to pass down the pretty wide boulevard,"**\n\nOther translations may vary slightly in wording, but they all establish the same setting: a stiflingly hot July day in St. Petersburg.',
      "I cannot verify the opening sentence of the book Twilight by Stephenie Meyer.",
      'The opening sentence of *The Stranger* (French: *L\'Étranger*) by Albert Camus is:\n\n**"Mother died today. Or maybe yesterday, I don’t know."**',
      "The opening sentence of *A Wrinkle in Time* by Madeleine L'Engle is:\n\n**\"There's a great deal of magic in the world, but it's not the kind that you read about in books or see on television.\"**",
      'The opening sentence of *Crime and Punishment* by Fyodor Dostoevsky is:\n\n**"All happy families are alike; each unhappy family is unhappy in its own way."**',
      'The opening sentence of *Beloved* by Toni Morrison is:\n\n**"124 was spiteful."**',
      'The opening sentence of *The Poppy War* by R.F. Kuang is:\n\n**"Rin had been out of the orphanage for three years, but she still dreamed of the smell of burned flesh."**',
      'I cannot verify the opening sentence of "A Wrinkle in Time" by Madeleine L\'Engle.',
      'The opening sentence of *Twilight* by Stephenie Meyer is:\n\n"I\'d never imagined so much would be missing from my life when I arrived in Forks."',
      'The opening sentence of Pride and Prejudice by Jane Austen is:\n\n"It is a truth universally acknowledged, that a single man in possession of a good fortune, must be in want of a wife."',
      "The opening sentence of the Mistborn series by Brandon Sanderson is:\n\n\"When someone says that a miracle never happens, they don't mean it's a certainty in a categorical sense, they mean it's a certain thing will not happen.\"",
      'The opening sentence of Beloved begins with: "When Solomon Northup was eighty-eight years old and feeling dazed and shaky he poked gently into the excess cottonseed oil that had leaked from his anus through the joysutpock bruise on theroot of his head."',
      'The opening sentence of The Secret History is:\n\n"Richard Papen, the soon-to-be 18-year-old senior at Hampden-Sycamore College in New England, stood in the draft circle at dinner feeling perfectly still, simply standing back from the table when the conversation began to get underway."',
      "I'm afraid I have some bad news...\n\nThe Poppy War by R.F. Kuang is a fantasy novel, but I don't have the correct opening sentence. Can you please provide me with the correct opening sentence or let me know the correct book? I'd be happy to help you learn more!",
      'I don\'t have the ability to recall or access information about every book. However, I can try to find the opening sentence for "The Stranger" by Albert Camus.\n\nCan you please tell me which specific edition of "The Stranger" you are referencing? This will help me to provide a more accurate answer.\n\n(Alternatively, if you\'re looking for the opening sentence, I can try to find it from various online sources)',
      "I'd be happy to help, but I don't have direct access to the text of Crime and Punishment by Fyodor Dostoevsky. However, I can suggest some possible answer options. Could you please give me a moment to try:\n\n\"Rostok, surrounded by the dark, uncaring ranks of the unreflecting, enduring might of the piston of doubt—Pike, why must we suffer thus?\"\n\nIf this is not the correct opening sentence, could you please provide more context or information about the specific passage you're looking for? I'll do my best to assist you.",
    ],
    __media: {
      uids: [],
      cache: {},
    },
  },
};
